module.exports = __webpack_public_path__ + "static/media/5_elephant_angel.9bbe41b4.png";